export const FRAUDNET_APP_ID = 'SHOPLIST_NODE_WEB'
export const FRAUDNET_CORRELATION_ID = 'fraudnetCorrelationId'
